import {fetchJSONMemoized} from '@gaia/utils/fetchJSON';
import memoize from 'lodash/memoize';

import {fetchCustomLayerTypes} from './fetchLayerTypes';

interface AccessArgs {
    isAuthenticated: boolean;
    canAccessNonPublicSources: boolean;
}

export const fetchLayerTypeCategories = memoize(
    async function fetchLayerTypeCategories({
        isAuthenticated,
        canAccessNonPublicSources,
    }: AccessArgs): Promise<LayerTypeCategory[] | undefined> {
        const url = `/mapsources/v2/gaiagps-ng-2019/?nonPublicSources=${canAccessNonPublicSources}`;

        const mapsources = await fetchJSONMemoized(url, {
            credentials: 'same-origin',
        });

        const customLayerIds = (
            await fetchCustomLayerTypes({isAuthenticated, canAccessNonPublicSources})
        ).map((layerType) => layerType.id);

        return [
            ...mapsources.categories,
            ...(!isAuthenticated
                ? []
                : [
                      {
                          name: 'Custom Imports',
                          id: 'custom',
                          rank: 100,
                          description: '',
                          iconURL: '',
                          app: 'gaiagps-ng-2019',
                          sources: customLayerIds,
                      },
                  ]),
        ];
    },
    (argsObj: AccessArgs) => JSON.stringify(argsObj)
);
